/* eslint-disable no-underscore-dangle */
import { constants } from 'conviva-design/es/components/Table';

export const FONT_FAMILY = 'Roboto';

export const INTERNAL_UNKNOWN = 'CONVIVA_INTERNAL_UNKNOWN';
export const UNKNOWN = 'UNKNOWN';

export const ALL_TRAFFIC = 'Filters';
export const LIVE_TRAFFIC = 'Live Traffic';
export const VOD_TRAFFIC = 'VOD Traffic';

export const POPULATION_THRESHOLD_BASELINE = 'Audience Threshold for';

export const MODAL_NONE = 0;
export const MODAL_COMPARE = 1;

export const HOME_SHORT_PATH = '/';

export const DATE_SHORTCUTS = {
  last6Hours: 'Last 6 hours',
  past24Hours: 'Last 24 hours',
  today: 'Today',
  yesterday: 'Yesterday',
  lastWeek: 'Last week',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  last7Days: 'Last 7 days and today',
  past7Days: 'Last 7 days',
  past14Days: 'Last 14 days',
  past30Days: 'Last 30 days',
  past90Days: 'Last 90 days',
  past1Year: 'Last 1 year',
};

export const METRICS_CONTAINER_METRICS_VIEW = {
  DEFAULT_ORDER: 1, // pre-defined order of charts
  LIST: 2, // shows charts in minimized mode
  LEXICAL: 3, // alphabetical order
  SORT_BY_DEVIATION: 4,
  ALL_METRICS: 5, // if charts are removed, this options un-hide all of them
  EXPORT: 6,
  AUDIENCE_METRICS: 7,
};

export const TABS_MAX_LENGTH = 500;

export const PAGE_TYPE = {
  SHARING: 1,
  TEMP_DASHBOARD: 2,
  SAVED_DASHBOARD: 3,
};

export const USER_ROLE_READONLY = 'Read Only';

export const DEFAULT_SLIDER_CHART_TICKS = 12;
export const MAX_SLIDER_CHART_TICKS = 30;

export const PRECISION_POLICY_PATH = `${
  window.__POWERED_BY_QIANKUN__ ? '/app' : ''
}/precision/precision_policy`;
export const MBR_POLICY_PATH = `${
  window.__POWERED_BY_QIANKUN__ ? '/app' : ''
}/precision/mbr_policy`;
export const CHANGE_LOG_PATH = `${
  window.__POWERED_BY_QIANKUN__ ? '/app' : ''
}/experience-insights/change_log`;

export const GRAND_FILTER_FILTER_ALERT_MSG = `As part of your Pulse 5 packaging,
new tag limits apply to the tags used with both Pulse 4 and Pulse 5 filters.
While filters are shared across Pulse 4 and Pulse 5, the available tags and tag
limits will be defined in your Pulse 5 package. Reach out to your Conviva
representative for more details.`;

export const AND_DELIMITER = '__AND__';
export const OR_DELIMITER = '__OR__';

export const FILTERS_CACHE_EXPIRY = 10; // in minutes

export const NOC_DRILLDOWN = 'noc-drilldown';
export const BROKEN_ASSETS_DRILLDOWN = 'broken-assets-drilldown';
export const NEWAPP_DRILLDOWN = 'newapp-drilldown';

// layout
export enum LAYOUT_MAP {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
